import { currentFacilityActionTypes } from "./currentFacilityActionTypes";

export const storeFacilityDetails = (data) => ({
  type: currentFacilityActionTypes.STORE_FACILITY_DETAILS,
  payload: data,
});
